/**
 * Balance check that additionally gates a level transition
 * (DunningTypeLevelTransition): whether and in which direction the balance
 * must have changed since the level started for the transition to fire.
 *
 * Mirrors backend enum {@code com.mvs.backend.bd.enums.BdDunningBalanceCheck}.
 * Ordinal mapping (MUST match the backend enum):
 *   0 = NONE
 *   1 = REMAINED
 *   2 = INCREASED
 *   3 = DECREASED
 *
 * @ticket bd-dunningtype-overview
 */
export enum BdDunningBalanceCheck {
    NONE,
    REMAINED,
    INCREASED,
    DECREASED
}

/**
 * German UI labels for BdDunningBalanceCheck values.
 */
export const BD_DUNNING_BALANCE_CHECK_LABELS: Record<BdDunningBalanceCheck, string> = {
    [BdDunningBalanceCheck.NONE]: 'Keine Prüfung',
    [BdDunningBalanceCheck.REMAINED]: 'Saldo unverändert',
    [BdDunningBalanceCheck.INCREASED]: 'Saldo erhöht',
    [BdDunningBalanceCheck.DECREASED]: 'Saldo verringert'
};
